export const EXSBITEM_CREATE_RESET = 'EXSBITEM_CREATE_RESET'
export const EXSBITEM_CREATE_SET_CREATED = 'EXSBITEM_CREATE_SET_CREATED'
export const EXSBITEM_CREATE_SET_ERROR = 'EXSBITEM_CREATE_SET_ERROR'
export const EXSBITEM_CREATE_SET_VIOLATIONS = 'EXSBITEM_CREATE_SET_VIOLATIONS'
export const EXSBITEM_CREATE_TOGGLE_LOADING = 'EXSBITEM_CREATE_TOGGLE_LOADING'
